import type { useJournalService } from '@/entities/journal/api';
import type { IChiefEditor } from '@/entities/journal/model/types';
import { logError, normalizeError } from '@/shared/lib/errors';

type ChiefEditorService = Pick<
  ReturnType<typeof useJournalService>,
  'getChiefEditor' | 'getTopics'
>;

export const fetchChiefEditorProfile = async (
  journalService: ChiefEditorService,
  actionTag: string,
): Promise<Partial<IChiefEditor>> => {
  const { data } = await journalService.getChiefEditor();
  const editor = data?.editor;
  if (!editor) return {};

  try {
    const topicsResponse = await journalService.getTopics({ user_id: editor.id });
    return { ...editor, topics: topicsResponse.data ?? [] };
  } catch (error) {
    logError(normalizeError(error), { action: actionTag });
    return { ...editor, topics: [] };
  }
};
